const urlOf = (image) => (typeof image === "string" ? image : image?.filePath) || null;

/**
 * A song's artwork URL. Livestream payloads carry it either as a URL string
 * or as a `{ filePath }` object depending on which player sent them.
 */
export function artworkUrlOf(song) {
  return urlOf(song?.thumbnailImg) || urlOf(song?.coverImg);
}

/** Artwork in the `{ filePath }` shape the web and app players read. */
export function artworkPayloadOf(song) {
  const url = artworkUrlOf(song);
  return url ? { filePath: url } : null;
}

const FALLBACK_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">' +
  '<rect width="40" height="40" rx="6" fill="#1a1a23"/>' +
  '<path d="M17 12.5 27 10v14.2a3.3 3.3 0 1 1-1.8-2.9V14.3l-6.4 1.6v10.3a3.3 3.3 0 1 1-1.8-2.9z" fill="#6c6c80"/>' +
  "</svg>";

/** Shown when a song has no artwork: a music note on a dark tile. */
export const ARTWORK_FALLBACK = `data:image/svg+xml,${encodeURIComponent(FALLBACK_SVG)}`;
